import { completeStage, selectStage } from '../../../redux/slices/stageSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hook';

import { DarkButton } from '../../../components/dark-button';
import InfoCardItem1 from '../../../components/info-card-item1';
import React from 'react';
import { selectProfile } from '../../../redux/slices/profileSlice';
import { selectSession } from '../../../redux/slices/sessionSlice';
import { useTranslation } from 'react-i18next';

export default function LetsGetStarted() {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const { token, reservation, propertyInfo } = useAppSelector(selectSession);
	const { currentProfile } = useAppSelector(selectProfile);
	const { stages, stage } = useAppSelector(selectStage);
	const handleStart = () => {
		// Stage progression handled in DisplayPage
		dispatch(
			completeStage({
				token,
				stageID: stage?.stepID,
				ReservationID: reservation?.ReservationID,
				type: 'checkin',
				confirmationNo: reservation?.PmsConfirmationNo,
				stages,
				propertyCode: propertyInfo?.propertyCode ?? '',
				profileID: currentProfile?.profileID ?? null,
			})
		);
	};

	return (
		<div className="d-flex flex-column justify-content-between">
			{/* CONTENT */}
			<div className="container text-center pt-5">
				{/* Illustration */}
				{/* <div className="app-logo" /> */}

				{/* Heading */}
				<h2 className="lgs-title">{t('LetsGetStartedTitle')}</h2>

				{/* Description */}
				<p className="lgs-description">{t('LetsGetStartedDescription')}</p>

				{/* Step Cards */}
				<div className="mt-4 text-start d-flex flex-column gap-3">
					<InfoCardItem1
						className="lgs-card"
						iconClass="lgs-icon-face"
						title={t('LetsGetStartedCardTitle1')}
						description={t('LetsGetStartedCardDescription1')}
					/>

					<InfoCardItem1
						iconClass="lgs-icon-document"
						title={t('LetsGetStartedCardTitle2')}
						description={t('LetsGetStartedCardDescription2')}
					/>

					<InfoCardItem1
						iconClass="lgs-icon-travel"
						title={t('LetsGetStartedCardTitle3')}
						description={t('LetsGetStartedCardDescription3')}
					/>
				</div>
			</div>

			{/* FIXED BOTTOM BUTTON */}
			<div
				className="fixed-bottom border-top d-flex justify-content-center theme-footer  p-3"
				style={{
					zIndex: 1050,
					backgroundColor: 'transparent',
					paddingBottom: 'env(safe-area-inset-bottom)',
				}}>
				<DarkButton
					text={t('LetsGetStartedButton')}
					onClick={handleStart}
					filled
					hideArrow
					className="det-proceed-button"
				/>
			</div>
		</div>
	);
}
